import { FontIcon, FontIcons, FontWeights, StandardLink, StandardText } from '@brandfolder/react';
import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';

import { WhitelabelContext } from '@context/whitelabel';

type SettingsManageBrandguideProps = HTMLAttributes<HTMLDivElement>;

const UnstyledSettingsManageBrandguide: FunctionComponent<SettingsManageBrandguideProps> = (
  props
) => {
  const { whitelabel } = useContext(WhitelabelContext);
  return (
    <div
      {...props}
      className={classNames({
        'global-settings__wrapper': true,
        [`${props.className}`]: !!props.className
      })}
    >
      <FontIcon className="manage-brandguide" icon={FontIcons.BrandguideV2} iconSize={20} />
      <div className="manage-brandguide-header-wrapper">
        <StandardText
          className="manage-brandguide-header-wrapper__manage-brandguide-text"
          weight={FontWeights.Medium}
        >
          management
        </StandardText>
        <StandardText className="manage-brandguide-header-wrapper__manage-brandguide-description">
          Modify or delete your Brandguide.
        </StandardText>
        <StandardLink
          className="manage-brandguide-header-wrapper__manage-brandguide-link"
          href={`${whitelabel.BOULDER_URL}/organizations`}
          target="_blank"
        >
          Manage Brandguide
        </StandardLink>
      </div>
    </div>
  );
};

const StyledSettingsManageBrandguide = styled(UnstyledSettingsManageBrandguide)`
  display: flex;
  margin-top: 24px;

  .manage-brandguide {
    margin-right: 15px;
  }

  .manage-brandguide-header-wrapper {
    &__manage-brandguide-text {
      text-transform: uppercase;
    }

    &__manage-brandguide-link {
      margin-top: 24px;
    }
  }
`;

export const SettingsManageBrandguide: FunctionComponent<SettingsManageBrandguideProps> = (
  props
) => {
  return <StyledSettingsManageBrandguide {...props} />;
};
